<template>
  <div>
    <div :class="drawer">
      <b-navbar-brand id="hyperDrillMapsLogo" to="/dashboard" class="mb-4">
        <img
          alt="DrillMaps"
          class="logo"
          src="@/assets/logo.png"
          width="140px"
        />
      </b-navbar-brand>

      <div class="menu-area">
        <div class="menus">
          <List
            to="/dashboard"
            :label="$t('adminNav.dashboard')"
            icon="dashboard"
          />
        </div>
        <div class="mb-5">
          <button class="logout-button" @click="$root.logout()">
            <span v-if="getSideDrawer">{{ $t("adminNav.logout") }}</span>
            &nbsp;&nbsp;<i class="fa fa-sign-out"></i>
          </button>
        </div>
      </div>
    </div>
    <div :class="backdrop" @click="$emit('click')"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import List from "@/components/List";

export default {
  props: ["toggler"],
  computed: {
    backdrop() {
      return this.toggler ? "dm-backdrop" : "dm-backdrop-hide";
    },
    drawer() {
      return this.toggler ? "dm-mobile-show" : "dm-mobile";
    },
    ...mapGetters({
      getSideDrawer: "getSideDrawer",
      planId: "getPlanId",
      user: "getUser"
    })
  },
  components: {
    List
  }
};
</script>

<style scoped>
.dm-mobile {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 20px 40px;
  transform: translateX(-100%);
  background: var(--white);
  width: 75%;
  z-index: 9999;
  transition: all 0.3s ease;
}
.dm-mobile-show {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 20px 40px;
  transform: translateX(0);
  background: var(--white);
  width: 75%;
  z-index: 9999;
  transition: all 0.5s ease;
}
.dm-backdrop {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
  transform: translateX(0);
  transition: all 0.3s ease;
}
.dm-backdrop-hide {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
  transform: translateX(-100%);
  transition: all 0.5s ease;
}
.logout-button {
  color: var(--secondary-color);
  background: none;
  outline: none;
  border: none;
  white-space: nowrap;
}
</style>
